<template>
    <span v-if="tributeVideoStore.submissionsOpen"
        :style="{ backgroundColor: bgColor }" :class="['deadline-reminder', !tributeVideoStore.deadlineExpired ? 'active' : 'expired']"
        >The deadline {{ tributeVideoStore.deadlineExpired ? 'was' : 'is' }} {{ tributeVideoStore.deadlineToLocal | moment('LLL') }}</span
    >
    <span v-else :style="{ backgroundColor: bgColor }" class="deadline-reminder expired"
        >Submissions Closed</span
    >
</template>
<script>
// import { mapGetters } from 'vuex';
import { mapStores } from 'pinia';
import { useTributeVideoStore } from '@/stores/tributeVideo';
export default {
    props: {
        bgColor: {
            type: String,
            default: '#f3f4f6',
        },
    },
    computed: {
        // ...mapGetters('tributeVideo', ['deadlineExpired', 'deadlineToLocal', 'submissionsOpen']),
        ...mapStores(useTributeVideoStore),
    },
};
</script>
<style lang="scss" scoped>
.deadline-reminder {
    // background: #f3f4f6;
    border-radius: 20px;
    padding: 5px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    width: fit-content;
    margin: 2% auto 0;

    &::before {
        content: '';
        display: inline-block;
        background: $primary-grey;
        width: 6px;
        height: 6px;
        border-radius: 100%;
    }
    &.active {
        &::before {
            background: $medium-green;
        }
    }
    &.expired {
        &::before {
            background: $medium-red;
        }
    }
}
</style>
